export default {
    namespaced: true,
    pbx_master_account: {
      title: "Cuenta Maestra | Cuentas Maestras",
      name: "nombre",
      domain: "dominio",
      sip_port: "Puerto SIP",
      tls_sip_port: "Puerto SIP TLS",
      ws_url: "WS URL",
      ws_binding_port: "Puerto WS",
      wss_binding_port: "Puerto WSS",
      external_sip_ip: "IP SIP externa",
      external_rtp_ip: "IP RTP externa",
      call_recording: "Grabación de llamadas habilitada",
      queue_timeout: "Tiempo de espera en la cola",
      seconds: "segundos",
      api_url: "API URL",
    },
  };
